import { Fragment } from 'react'
import './UserAvatar.scss'

export interface UserAvatarProps {
    userName: string
    userLastname: string
    userNickname?: string
    avatarImage: string
}

const UserAvatar = (props: UserAvatarProps) => {
    
    const { userName, userLastname, userNickname, avatarImage } = props
    const userAvatarClass = 'user-avatar'
    let userAvatar = (
        <Fragment>{`${userNickname ? userNickname.charAt(0).toUpperCase() : userName.charAt(0).toUpperCase()}${
            userNickname ? userNickname.charAt(userNickname.length > 1 ? 1 : 0).toUpperCase() : userLastname.charAt(0)
                .toUpperCase()}`}</Fragment>
    )
    if (!!avatarImage) {
        userAvatar = (
            <Fragment>
                <img
                    src={avatarImage}
                    className={`${userAvatarClass}__image`}
                    alt=''
                />
            </Fragment>
        )
    }
    return (
        <div className={userAvatarClass}>
            {userAvatar}
        </div>
    )
}

export default UserAvatar
